<h1>
	{{ title }}
	<div style="float: right">
		<button
			type="button"
			class="btn btn-primary"
			(click)="planificationCallSubject$.next()"
			>
			Planifier un &eacute;v&eacute;nement
		</button>
	</div>
</h1>

<!-- filtres -->
<acces-search-filters [showFiltreTarifNegatif]="false" (onApplyFilters)="applySearchCriteria($event)" [user]="user"></acces-search-filters>

<!-- piles des acces  -->
<acces-liste-tarif-negatif [refreshCommands]="reloadAccesPlanifieCommands" [user]="user" (accesClicked)="onAccesClicked($event)" [etat]="accesEtat.PLANIFIE"
	[title]="'Accès Planifié'" [foldedPannel]="false" (accesActionRequest)="onActionRequest($event)"></acces-liste-tarif-negatif>

<acces-liste 
	[refreshCommands]="reloadAccesDemandesCommands" [user]="user" (accesClicked)="onAccesClicked($event)" [etat]="accesEtat.ENREGISTRE"
	[title]="'Accès En attente de validation'" [highlightable]="true" (accesActionRequest)="onActionRequestSingle($event)"></acces-liste>

<acces-liste-tarif-negatif [refreshCommands]="reloadAccesEnCoursCommands" [user]="user" (accesClicked)="onAccesClicked($event)" [etat]="accesEtat.EN_COURS" 
	[title]="'Accès en cours'" (accesActionRequest)="onActionRequest($event)"></acces-liste-tarif-negatif>

<acces-liste [refreshCommands]="reloadAccesDemandeFermetureCommands" [user]="user" (accesClicked)="onAccesClicked($event)" [etat]="accesEtat.EN_COURS" 
	[title]="'Accès En attente de fermeture'" (accesActionRequest)="onActionRequestSingle($event)"></acces-liste>

<acces-liste [refreshCommands]="reloadAccesTerminesCommands" [user]="user" 
	(accesClicked)="onAccesClicked($event)" [title]="'Accès Terminé'" (accesActionRequest)="onActionRequestSingle($event)" [etat]="accesEtat.FERME" >
</acces-liste>

<acces-liste [refreshCommands]="reloadAccesRefusesCommands" [user]="user" [etat]="accesEtat.REFUSE" 
	(accesClicked)="onAccesClicked($event)" [title]="'Accès Refusé'" (accesActionRequest)="onActionRequestSingle($event)"></acces-liste>

<div class="navbar">
	<button type="button" class="btn btn-primary" (click)="toutExporter()">Tout exporter</button>
</div>

<!-- affichage du détail de l'acces -->
<acces-details [displayCommands]="displayAccesDetailsSubject" (notificationRequested)="notify($event)"></acces-details>

<!-- popup de fermeture acces -->
<acces-fermeture [displayCommands]="displayAccesFermetureCommands" 
	(closedAccesSaved)="onAfterFermetureAcces($event[0], $event[1])" ></acces-fermeture>

<!-- popup de coactivite solaire -->
<coactivite-solaire-checker
	[id]="'coactiviteSolCheckerDialogFromListe'"
	[checkCommands]="checkCoactiviteSolaireCommands"
	(decisionIssued)="onCoactiviteDecision($event[0], $event[1])"
	>
</coactivite-solaire-checker>

<!-- popup de coactivite eolien -->
<coactivite-eolien-checker
	[id]="'coactiviteEolCheckerDialogFromListe'"
	[checkCommands]="checkCoactiviteEolienCommands"
	(decisionIssued)="onCoactiviteDecision($event[0], $event[1])"
	>
</coactivite-eolien-checker>

<!-- popup d'association arrêts -->
<acces-association-arrets-dialog
	[displayCommands]="displayAssociationArretsCommands"
	(associationArretsSaved)="onCompletingAssociationArrets($event)"
	>
</acces-association-arrets-dialog>

<acces-refus [displayCommands]="displayRefusAccesCommands" (decisionIssued)="onCompletingRefus($event[0], $event[1])"></acces-refus>

<planification-tarif-negatif [displayCommands]="planificationCallSubject$"></planification-tarif-negatif>

<modification-tarif-negatif [displayCommands]="modificationTarifNegatifCallSubject$"></modification-tarif-negatif>

<job-progress-dialog [displayCommands]="jobProgressDisplayCommands$"></job-progress-dialog>
